import React, {Component, useEffect, useState} from 'react';
import {Col, Button, ButtonGroup, FormControl, Image, InputGroup, Modal, Row} from "react-bootstrap";
import {HotTable} from '@handsontable/react';
import './handsontable.full.css';
import {toastr} from "react-redux-toastr";
import {Loader} from "../../views/Wizard";
import {fetch_folders} from "../../views/Folders/actions";
import {bulkSaveOutputs, uploadImage} from "./actions";
import PenguinSlider from "../PenguinSlider";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import './style.css';
import ImageBox from "../ImageBox";
import DesignResourcesPanel from "../designResourcesPanel";
import FolderDropdown from "./FolderDropdown";

// const HotTable = Handsontable.react.HotTable;

/*
sample json

[{
    images: [{label_id:"label id here",src:"replacement image url here", image_fit: "cover or contain"}],
    text: [{label_id:"label id here",text:"replacement text goes here"}]
}]

//sample code to bulk generate

editor.load(design_file); (to get current design file just do window.design_editor.save())
editor.draw();
await editor.wait_to_load();
editor.draw();
await editor.proceduralGeneration(pg_json,true);
modified_design_thumbnail = editor.export('low');
modified_design_design_file = editor.save();

*/

/***
 * Util function that returns true is all elements in an array are null or blank strings.
 * @param row
 * @returns {boolean | *}
 */
const isRowEmpty = (row) => {
    return Object.keys(row).filter(k => (row[k] != null && row[k] !== undefined && String(row[k]).trim().length > 0)).length === 0;
};

const categorySelectionStyles = {

    option: (provided, state) => ({
        ...provided,
        textAlign: 'left',
        backgroundColor: state.isSelected ? '#C8CDD4' : (state.isFocused ? '#F1F2F3' : 'white'),
    }),

    menu: (provided, state) => ({
        ...provided,
        width: '275px'
    })
};

const imageColumnRenderer = (instance, td, row, col, prop, value, cellProperties) => {
    let displayVal;
    // cellProperties.className = "bulk_edit_image_cell";
    if (value === null || value === undefined) displayVal = '<button class="bulk_edit_image_upload_btn" onclick="imageUploadOnClick(' + row + ',' + col + ')">Select Image</button>';
    else displayVal = '<span onclick="imageUploadEditOnClick(' + row + ',' + col + ')" class="fas fa-check bulk_edit_image_upload_check"/>';
    td.style.padding = 0;
    td.style.textAlign = 'center';
    td.innerHTML = displayVal;
    return td;
};

class BulkEditDataModal extends React.Component {

    constructor(props) {
        super(props);
        this.data = [
            []
        ];
        this.state = {
            activeTab: 'home',
            selectedImage: null,
            activeRow: null,
            activeCol: null,
            selectedImageUrl: null,
            folders: [],
            activeFolder: null
        };
        this.id = 'hot';
        this.hotTableComponent = React.createRef();
    }


    componentDidMount() {
        window.imageUploadOnClick = this.imageUploadOnClick;
        window.imageUploadEditOnClick = this.imageUploadEditOnClick;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.show !== prevProps.show && this.props.show === true) {
            fetch_folders()
                .then(data => data.json())
                .then(data =>
                    this.setState({
                        folders: data.data.filter(x => x.folder.type === 'photo')
                    }))
                .catch(e => {
                    console.error(e);
                    toastr.error("Something went wrong.");
                });
        }
    }


    getColHeaders = () => {
        const textHeaders = this.props.labels.filter(x => x.type === 'text').map(x => ({
            data: x.text,
            renderer: 'text'
        }));
        const imageHeaders = this.props.labels.filter(x => x.type === 'image').map(x => ({
            data: x.text,
            renderer: imageColumnRenderer,
            readOnly: true
        }));
        const columns = textHeaders.concat(imageHeaders);
        const colHeaders = columns.map(x => x.data);
        return [columns, colHeaders];
    };

    imageUploadOnClick = (row, col) => {
        this.setState({
            activeTab: "image",
            activeRow: row,
            activeCol: col,
        })
    };

    imageUploadEditOnClick = (row, col) => {

        const fileSrc = this.hotTableComponent.current.hotInstance.getDataAtCell(row, col);

        this.setState({
            activeTab: "image",
            activeRow: row,
            activeCol: col,
            selectedImageUrl: global.config.static_file_server_path + fileSrc
        })
    };


    handleImageUpload = event => {
        this.setState({
                selectedImage: event.target.files[0],
                selectedImageUrl: URL.createObjectURL(event.target.files[0])
            },
            () => {
                if (this.state.selectedImage) {
                    uploadImage({image: this.state.selectedImage, folderId: this.props.user.my_photos_folder})
                        .then(res => res.json())
                        .then((data) => {
                            const fileUrl = data.data.resources[data.data.resources.length - 1].path;
                            this.hotTableComponent.current.hotInstance.setDataAtCell(this.state.activeRow, this.state.activeCol, fileUrl);
                            this.setState(({
                                activeTab: 'home',
                                activeRow: null,
                                activeCol: null,
                                selectedImageUrl: null,
                                selectedImage: null
                            }))
                        })
                        .catch((e) => {
                            console.error(e);
                            toastr.error("Something went wrong");
                        })
                }
            }
        )
    };

    imageFromFolderOnClick = (resource) => {
        this.hotTableComponent.current.hotInstance.setDataAtCell(this.state.activeRow, this.state.activeCol, resource.src);
        this.setState(({
            activeTab: 'home',
            activeRow: null,
            activeCol: null,
            selectedImageUrl: null,
            selectedImage: null,
            activeFolder: null
        }))
    };


    ImageSelectionHomeContainer = () => (
        <React.Fragment>
            <Image style={{maxWidth: 200, maxHeight: 200, margin: 'auto', display: 'block'}}
                   src={this.state.selectedImageUrl}/>
            <Button style={{marginTop: 15, marginBottom: 30}}
                    className={"btn btn-sm btn-orange btn-block"}
                    onClick={() => {
                        window.document.getElementById('bulk_upload_image_input').click()
                    }}
            >
                <span className="fa fa-upload"/>
                Upload New Image
                <input
                    accept="image/*"
                    id="bulk_upload_image_input"
                    style={{display: 'none'}}
                    type="file"
                    name="file"
                    onChange={this.handleImageUpload}
                />
            </Button>
            <hr/>
            <Row style={{
                fontSize: 14,
                paddingBottom: 20,
                paddingRight: 10
            }}>
                <Row style={{paddingBottom: 5}}>
                    <b>Choose image from folders</b>
                </Row>
                <PenguinSlider id="past_design_slider" height={120}>
                    {this.state.folders.map((folder, idx) => (
                        <Col key={idx} xs={2} className="grey_bg_on_hover">    
                            <ImageBox
                                key={'bulk_edit_folders_slider' + idx}
                                on_click={() => this.setState({activeFolder: folder.folder._id})}
                                idx={idx}
                                image_src={"https://img.icons8.com/cotton/64/000000/folder-invoices--v1.png"}
                                image_style={{height:40}}
                                name={(folder.folder.name.length < 25 ? folder.folder.name : folder.folder.name.substring(0, 22) + '...')}
                                disable_overlay={true}
                                container_style={{marginLeft:15}}
                            />
                            <div style={{textAlign:'center',fontWeight:'bold',overflow:'hidden',textOverflow:'ellipsis'}}>{(folder.folder.name.length < 25 ? folder.folder.name : folder.folder.name.substring(0, 22) + '...')}</div>
                        </Col>
                    ))}
                </PenguinSlider>
            </Row>
        </React.Fragment>
    );

    ImageSelectionFolderContainer = () => (
        <div style={{height: '100%', overflowY: 'auto'}}>
            <DesignResourcesPanel
                on_drag_start={() => {}}
                on_drag={() => {}}
                on_drag_end={() => {}}
                on_click={this.imageFromFolderOnClick}
                image_height={'120px'}
                col_size={6}
                resources={this.state.folders.find(x => x.folder._id === this.state.activeFolder).folder.resources.map(element => ({src : element.path, low_src: element.low_path}))}
            />
        </div>
    );

    ImageSelectionContainer = () => (
        <div style={{
            height: 500,
            width: '100%',
            'display':'block'
        }}>
            {this.state.activeFolder ? <this.ImageSelectionFolderContainer/> : <this.ImageSelectionHomeContainer/>}
        </div>

    );

    PanelView = () => {
        const [columns, colHeaders] = this.getColHeaders();

        return (
            <React.Fragment>
                <div style={{'display': this.state.activeTab === 'home' ? 'block' : 'none'}}>
                    < HotTable
                        ref={this.hotTableComponent}
                        id={this.id}
                        data={this.data}
                        colHeaders={colHeaders}
                        columns={columns}
                        rowHeaders={true}
                        width="100%"
                        height="500"
                        contextMenu={['row_above', 'row_below', 'remove_row']}
                        bindRowsWithHeaders={'strict'}
                        minSpareRows={3}
                        maxRows={100}
                        maxCols={this.props.labels.length}
                        startRows={20}
                        stretchH="all"
                        licenseKey="non-commercial-and-evaluation"/>
                </div>
                {this.state.activeTab === 'home' ? <center><Button onClick={() => this.props.onHide(this.data)} className="btn btn-orange">Save</Button></center> : null}
                {this.state.activeTab === 'image' && (<this.ImageSelectionContainer/>)}
            </React.Fragment>
        );
    };

    backButtonOnClick = () => {
        if (this.state.activeFolder) {
            this.setState({
                activeFolder: null
            })
        }
        else {
            this.setState({
                activeTab: 'home',
                activeRow: null,
                activeCol: null,
                selectedImageUrl: null,
                selectedImage: null
            })
        }
    };

    Header = () => {
        if (this.state.activeTab === 'home') {
            return (
                <span>
                    Add data
                </span>
            )
        }
        else {
            return (
                <div style={{cursor: "pointer"}} onClick={this.backButtonOnClick}>
                    <span style={{color: 'grey', fontWeight: 'bold', marginRight: 10}} className="fa fa-arrow-left"/>
                    {this.state.activeFolder ? "Click on image to select" : null}
                </div>
            )
        }
    };

    render() {
        return (<Modal
                show={this.props.show}
                onHide={() => this.props.onHide(this.data)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <this.Header/>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <this.PanelView/>
                </Modal.Body>
            </Modal>
        );
    }
}

class GenerateBulkDesignsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            designs: [],
            isLoading: true,
            folders: [],
            selectedFolder: null,
            generationComplete: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.show !== prevProps.show && this.props.show === true) {

            this.setState({
                designs: [],
                isLoading: true
            });

            this.fetchFolders();
            this.generateAllDesigns();
        }
    }


    fetchFolders = () => {
        fetch_folders()
            .then(data => data.json())
            .then(data => {
                let designFolders = data.data.filter(x => x.ownership === 'owned' && x.folder.type === 'design');
                if (this.props.user && this.props.user.my_designs_folder) {
                    designFolders = designFolders.filter(x => x.folder._id !== this.props.user.my_designs_folder)
                }
                this.setState({
                    folders: designFolders
                })
            })
            .catch(e => {
                console.error(e);
                toastr.error("Something went wrong.");
            });
    };

    generateAllDesigns = async () => {
        try {
            let currData = this.props.data;
            let design = new window.DM_Design();
            let design_file = window.design_editor.design.save();

            for (let i = 0; i < currData.length; i++) {

                let rowData = this.props.labels.reduce((acc, elem) => ({
                    ...acc,
                    [elem.text]: currData[i][elem.text]
                }), {});

                //skip blank rows
                if (isRowEmpty(rowData)) {
                    if (i === currData.length - 1) this.setState({generationComplete: true});
                    continue;
                }

                let data_json = {
                    'text': [],
                    'images': []
                };

                for (let j = 0; j < this.props.labels.length; j++) {
                    if (this.props.labels[j].type === 'text') {
                        data_json['text'].push({
                            label_id: this.props.labels[j].id,
                            text: rowData[this.props.labels[j].text]
                        });
                    } else if (this.props.labels[j].type === 'image') {
                        data_json['images'].push({
                            label_id: this.props.labels[j].id,
                            src: rowData[this.props.labels[j].text],
                            image_fit: 'cover'
                        });
                    }
                }

                design.load(design_file);
                design.base_width = 169;
                // design.base_width = design.get_width();
                design.handleWindowResize();
                design.draw();
                await design.wait_to_load();
                design.draw();
                await design.proceduralGeneration(data_json, true);
                const modified_design_file = design.save();
                const modified_thumbnail = design.pages[0].export('low');
                const modified_inner_html = design.pages[0].get_html();
                const snapshot_html = design.pages[0].get_html(true);
                if (i === 0) this.setState({isLoading: false});
                this.setState({
                    designs: this.state.designs.concat([{
                        design_file: modified_design_file,
                        thumbnail: modified_thumbnail,
                        inner_html: modified_inner_html,
                        snapshot_html: snapshot_html,
                        snapshot_width: Math.floor(design.get_width() * design.pixelsPerCm),
                        snapshot_height: Math.floor(design.get_height() * design.pixelsPerCm)
                    }])
                });
                if (i === currData.length - 1) this.setState({generationComplete: true});
            }
            if (this.state.isLoading) this.setState({isLoading: false})
        } catch (e) {
            console.error(e);
            toastr.error("Something went wrong");
        }
    };

    handleFolderSelectionChange = (selectedFolder) => {
        this.setState({selectedFolder});
    };

    handleBulkSaveToFolder = () => {
        bulkSaveOutputs({original_save_id: window.design_editor.design.design_save_id, designs: this.state.designs.map(o => ({design_file: o.design_file})), folderId: this.state.selectedFolder._id})
        .then(data => data.json())
        .then(data => {
            try{
                //updating thumbnails
                if(data.response_code == 1){
                    for(var i=0;i<data.data.length;i++){
                        let html_data = this.state.designs[i].snapshot_html;
                        let rendering_parameters =  { width: this.state.designs[i].snapshot_width, height: this.state.designs[i].snapshot_height, update_type:'saved_design', update_thumbnail: true, model_id: data.data[i]._id };
                        let data_snapshot = { type: 'jpg', html_data, rendering_parameters }
                        fetch(global.config.server_path + 'render/initiate', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify(data_snapshot)})
                    }
                }
            }catch(err){
                console.log(err);
            }
            this.props.onHide();
            toastr.success("Saved to folder!")
        })
        .catch((e) => {
            console.error(e);
            toastr.error("Something went wrong");
        })
    };

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
            >
                <Modal.Header style={{padding: 14}}>
                    <Modal.Title style={{display: 'flex', justifyContent: 'flex-start'}}>
                        <div style={{marginRight: 4}}>
                            <FolderDropdown
                                folders={this.state.folders}
                                setSelectedFolder={(folder) => this.setState({selectedFolder: folder})}
                                fetchFolders={this.fetchFolders}
                                selectedFolder={this.state.selectedFolder}
                            />
                        </div>
                        <Button
                            className="btn-orange"
                            disabled={this.state.selectedFolder === null || !this.state.generationComplete}
                            onClick={this.handleBulkSaveToFolder}
                        >
                            Save
                        </Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{
                        display: 'flex',
                        flexFlow: 'row wrap',
                        width: '100%',
                        overflowY: 'auto',
                        height: 600
                    }}>
                        <Loader style={{width: '30%', height: '30%', position: 'absolute', left: '35%', top: '35%'}}
                                show_loader={this.state.isLoading}/>
                        {this.state.designs.map(x =>
                            /*<Image src={x.thumbnail} style={{
                                width: 169,
                                margin: 10
                            }}/>*/
                            <div style={{marginRight:'10px',marginLeft:'10px'}} dangerouslySetInnerHTML={{__html: x.inner_html}} />
                        )}
                        {this.state.designs.length === 0 && !this.state.isLoading ?
                            <span>Fill in data first to preview designs</span> : null}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}


const LabelDisplay = ({id, text, deleteOnClick,isSelected,type,selectionType, update_text}) => {
    const [ editing_active, set_editing_active ] = useState(false);
    const [ editing_value, set_editing_value ] = useState(false);

    useEffect(() => {
        set_editing_value(text);
        set_editing_active(false);
    },[text])

    const selectElement = () => {
        var active_page = window.design_editor.active_page;
        var obj;
        if(type == "text"){
            obj = active_page.findTextByLabelId(id,true);
        }else if(type == "image"){
            obj = active_page.findImageByLabelId(id,true);
            if(obj && obj.o){
                obj = obj.o
            }else{
                obj = null
            }
        }
        if(obj){
            window.design_editor.setSelection({object:obj})
        }
    }

    const delete_label = () => {
        var active_page = window.design_editor.active_page;
        var obj;
        if(type == "text"){
            obj = active_page.findTextByLabelId(id,true);
        }else if(type == "image"){
            obj = active_page.findImageByLabelId(id,true);
            if(obj && obj.o){
                obj = obj.o
            }else{
                obj = null
            }
        }
        if(obj && obj.user_labels){
            obj.user_labels[type] = ''
        }
        deleteOnClick(id)

        window.design_editor.addUndoChange()
    }

    const edit_label = () => {
        set_editing_active(true);
    }

    const update_text_onclick = () => {
        if(update_text){
            update_text(id, editing_value);
            set_editing_active(false);
        }
    }

    return (
        <div key={id}
            style={{paddingLeft: 12, paddingRight: 12, display: 'inline-flex', alignItems: 'center', width: '100%'}}>
                

            <Row onClick={selectElement} style={{cursor:'pointer',height:40,display:"flex", width:"100%", alignItems:"center", backgroundColor: isSelected? "#FF841F" : "white", fontSize: 16, marginRight: 5}}>
                <Col xs={2}>
                    <Image src={global.config.static_file_server_path + (type=="text"?(isSelected?'uploads/icons/Text_white.svg':'uploads/icons/Text.svg'):(isSelected?'uploads/icons/Photos_white.svg':'uploads/icons/Photos.svg'))} style={{height:30}} />
                </Col>
                <Col xs={7} style={{fontSize:'14px',height:30,paddingTop:5,paddingLeft:0,paddingRight:0}}>
                    {editing_active?(
                        <InputGroup style={{width: "100%"}}>
                            <FormControl
                                style={{color:"#595959",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0,bottom:'5px'}}
                                placeholder={'Untitled Label'}
                                value={editing_value}
                                type="text"
                                onChange={(e) => set_editing_value(e.target.value)}
                                onBlur={(e) => update_text_onclick()}
                                onKeyUp={(e) => {if(e.key == "Enter"){update_text_onclick(e)}}}
                            />
                        </InputGroup>
                    ):(<div style={{color:isSelected?'#ffffff':'#595959',padding:0,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{text}</div>)}
                </Col>
                <Col xs={3} style={{padding:0}}>
                    <i onClick={edit_label} style={{color:isSelected?'#ffffff':'#595959',marginLeft: 5, fontSize: 16}}
                    className="fas fa-edit"/>
                    <i onClick={delete_label} style={{color:isSelected?'#ffffff':'#595959',marginLeft: 5, fontSize: 16}}
                    className="fas fa-trash"/>
                </Col>
            </Row>
             
        </div>
    )
}   

const LabelInput = ({id, text, assigned, selected, isSelected, unAssignLabelOnClick, assignLabelOnClick, editMode, handleChange, renameOnClick, deleteOnClick, type, selectionType, isCurrentAssigned}) => {
    return (
        <div key={id}
             style={{paddingLeft: 12, paddingRight: 12, display: 'inline-flex', alignItems: 'center', width: '100%'}}>

            <span style={{color: assigned&&assigned.length>0 ? "orange" : "rgba(0,0,0,0)", fontSize: 16, marginRight: 5}} className="fas fa-check"/>
            {
                <>
                    <InputGroup style={{width: "100%", border: isCurrentAssigned?"3px solid orange":"none"}}>
                        <FormControl
                            style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 0}}
                            placeholder={'Untitled Label'}
                            value={text}
                            type="text"
                            onChange={(e) => handleChange(id, e)}
                        />
                    </InputGroup>
                    {type==selectionType && isSelected?(
                        <>
                            {isCurrentAssigned?(<i onClick={() => unAssignLabelOnClick(id)} style={{marginLeft: 5, fontSize: 16}}
                            className="far fa-times-circle"/>):(<i onClick={() => assignLabelOnClick(id)} style={{marginLeft: 5, fontSize: 16}}
                            className="far fa-check-circle"/>)}
                        </>
                    ):''}
                    <i onClick={() => deleteOnClick(id)} style={{marginLeft: 5, fontSize: 16}}
                       className="fas fa-trash"/>
                </>
            }
        </div>
    )
};

class BulkEditPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'text',
            labels: [],
            showDataModal: false,
            showGenerateDesignsModal: false,
            bulkEditData: [],
            edit_name_label_id: '',
            design_selection: null
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));


    componentDidMount() {
        console.log("MOUNTED",window.design_editor.design.bulk_edit_data.labels)
        this.setState({labels:window.design_editor.design.bulk_edit_data.labels});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.label_rules !== this.props.label_rules && this.props.design_selection != null) {
            const tab = this.props.label_rules === "text" ? "text" : "image";
            this.setState({
                activeTab: tab
            })
        }

        if (this.props.design_selection != null && this.props.design_selection != this.state.design_selection) {
            console.log("setting design selection")
            this.setState({
                design_selection: this.props.design_selection
            })
        }
    }

    closeDataModal = (data) => {
        this.set_state({
            bulkEditData: data,
            showDataModal: false
        }).then(() => {
            this.save_bulk_edit_data_to_design();
        })
    };

    LabelsContainer = () => {

        const labels = this.state.labels;
            // .filter(x => x.type === this.state.activeTab);

        return (
            <div style={{marginTop: 20}}>
                {/*<div style={{position: 'absolute', height: '100%', width: '100%', top: 0, left: 0, zIndex: 1}} onClick={this.props.labelOnSelect}/>*/}
                <div style={{marginTop: 20,fontSize:"14px",paddingLeft:12,paddingBottom:20,fontWeight:500,textAlign:"left"}}>
                    Select an object to start tagging.<br />Labels that you tagged will appear here
                </div>
                <div style={{overflowY: 'scroll', maxHeight: 'calc(100vh - 450px)'}}>
                    {/* {labels
                        .map(x => <LabelInput id={x.id} assigned={x.assigned} selected={x.selected} text={x.text}
                                              handleChange={this.editLabel}
                                              renameOnClick={this.renameLabelOnClick}
                                              deleteOnClick={this.deleteLabelOnClick}
                                              editMode={x.id == this.state.edit_name_label_id}
                                              unAssignLabelOnClick={this.unAssignLabelOnClick}
                                              assignLabelOnClick={this.assignLabelOnClick}
                                              isCurrentAssigned={this.get_value() == x.id}
                                              isSelected={this.is_selected()}
                                              type={x.type}
                                              selectionType={this.props.label_rules}
                        />)
                    } */}
                    {labels
                        .map(x => <LabelDisplay id={x.id}  text={x.text}
                                              deleteOnClick={this.deleteLabelOnClick}
                                              isSelected={this.get_value() == x.id}
                                              type={x.type}
                                              selectionType={this.props.label_rules}
                                              update_text={this.update_label_name}
                        />)
                    }
                </div>
                {/* <this.AddLabelBtn/> */}
            </div>
        );
    };

    hideGenerateDesignsModal = () => {
        this.setState({
            showGenerateDesignsModal: false
        })
    };

    AddLabelBtn = () => (
        <div onClick={this.addLabelOnClick}
             style={{float: 'right', padding: 12, cursor: 'pointer'}}>
            <span style={{marginRight: 5}}>Add Label</span>
            <i className="fas fa-plus-circle"/>
        </div>
    );

    save_bulk_edit_data_to_design = () => {
        if(window.design_editor){
            window.design_editor.design.bulk_edit_data.labels = JSON.parse(JSON.stringify(this.state.labels));
            // window.design_editor.design.bulk_edit_data.data = JSON.parse(JSON.stringify(this.state.bulkEditData));
        }
    }

    addLabelOnClick = () => {
        const id = Math.random().toString(36).substr(2, 16);
        this.set_state({
            labels: this.state.labels.concat([
                {
                    id: id,
                    text: "",
                    assigned: [],
                    selected: false,
                    type: this.state.activeTab
                }
            ])
        }).then(() => {
            this.save_bulk_edit_data_to_design();
        })
    };

    renameLabelOnClick = (id) => {
        this.set_state({edit_name_label_id: id})
    }

    update_label_name = (id, text) => {
        var label_find = window.design_editor.design.bulk_edit_data.labels.find(o => o.id == id);
        if(label_find){
            label_find.text = text

            this.set_state({
                labels: window.design_editor.design.bulk_edit_data.labels
            })

            window.design_editor.addUndoChange();
        }
    }

    deleteLabelOnClick = (id) => {
        this.set_state({
            labels: this.state.labels.filter(x => x.id !== id)
        }).then(() => {
            this.save_bulk_edit_data_to_design();
        })
    };

    editLabel = (id, e) => {
        this.set_state({
            labels: this.state.labels.map(x => {
                if (x.id === id) {
                    x.text = e.target.value;
                }
                return x;
            })
        }).then(() => {
            this.save_bulk_edit_data_to_design();
        });
    };

    unAssignLabelOnClick = (id) => {
        var {object_id, old_value} = this.set_value(this.props.label_rules, "");
        this.setState({
            labels: this.state.labels.map(x => {
                if (x.id === id) {
                    window._.pull(x.assigned, object_id)
                }
                return x;
            })
        });
        this.props.labelOnSelect();
    };

    assignLabelOnClick = (id) => {
        var {object_id, old_value} = this.set_value(this.props.label_rules, id);
        this.setState({
            labels: this.state.labels.map(x => {
                if (x.id === id) {
                    x.assigned.push(object_id)
                }else if(old_value && x.id == old_value){
                    window._.pull(x.assigned, object_id)
                }
                return x;
            })
        });
        this.props.labelOnSelect();
    };

    set_value = (field, value, index) => {
        let user_labels;
        let sel = this.state.design_selection;
        var object_id = "";
        if (sel) {
            if (sel.class_type == 'background') {
                user_labels = window.design_editor.active_page.background.user_labels;
                object_id = window.design_editor.active_page.background.id
            } else if (sel.get_parent('box') && sel.get_parent('box').image) {
                user_labels = sel.get_parent('box').image.user_labels
                object_id = sel.get_parent('box').image.id
            } else if (sel.type == 'image' || sel.type == 'text') {
                user_labels = sel.user_labels
                object_id = sel.id
            }
        }

        var old_value = ""
        if (user_labels) {
            if(field == this.props.label_rules && user_labels[field] != value){
                old_value =  user_labels[field];
            }
            user_labels[field] = value
        }

        this.setState({})

        return {old_value, object_id}
    };

    get_value = () => {
        let user_labels;
        let sel = this.state.design_selection;
        if (sel) {
            if (sel.class_type == 'background') {
                user_labels = window.design_editor.active_page.background.user_labels;
            } else if (sel.get_parent('box') && sel.get_parent('box').image) {
                user_labels = sel.get_parent('box').image.user_labels
            } else if (sel.type == 'image' || sel.type == 'text') {
                user_labels = sel.user_labels
            }
        }

        if (user_labels && this.props.label_rules && user_labels[this.props.label_rules]) {
            return user_labels[this.props.label_rules]
        }
    };

    is_selected = () => {
        let user_labels;
        let sel = this.state.design_selection;
        if (sel) {
            if (sel.class_type == 'background') {
                user_labels = window.design_editor.active_page.background.user_labels;
            } else if (sel.get_parent('box') && sel.get_parent('box').image) {
                user_labels = sel.get_parent('box').image.user_labels
            } else if (sel.type == 'image' || sel.type == 'text') {
                user_labels = sel.user_labels
            }
        }

        if (user_labels) {
            return true
        }else{
            return false
        }
    }

    checkLabelNamesValid = () => {
        const labelNames = this.state.labels.map(x => x.text);
        return labelNames.filter((item, index) => labelNames.indexOf(item) !== index).length === 0;
    };

    render() {
        return (
            <React.Fragment>
                <BulkEditDataModal bulkEditData={this.state.bulkEditData} show={this.state.showDataModal} onHide={this.closeDataModal}
                                   labels={this.state.labels}
                                   user={this.props.user}/>
                <GenerateBulkDesignsModal show={this.state.showGenerateDesignsModal}
                                          onHide={this.hideGenerateDesignsModal} data={this.state.bulkEditData}
                                          labels={this.state.labels}
                                          user={this.props.user}
                />
                {/* <ButtonGroup style={{marginBottom: 12}}>
                    <Button onClick={() => this.setState({activeTab: 'text'})}
                            className={this.state.activeTab === 'text' ? "btn btn-orange nohover" : "btn btn-orange-inverse nohover"}
                            style={{paddingTop: 6, paddingBottom: 6, width: 110, borderRadius: 3}}>Text</Button>
                    <Button onClick={() => this.setState({activeTab: 'image'})}
                            className={this.state.activeTab === 'image' ? "btn btn-orange nohover" : "btn btn-orange-inverse nohover"}
                            style={{paddingTop: 6, paddingBottom: 6, width: 110, borderRadius: 3}}>Image</Button>
                </ButtonGroup> */}
                <this.LabelsContainer/>
                <br />
                <div style={{paddingLeft: 12, paddingRight: 12, paddingBottom: 12, width: '100%'}}>
                    <Button
                        onClick={() => {
                            window.design_editor.deselectElements();
                            if (this.checkLabelNamesValid()) {
                                this.setState({showDataModal: true})
                            }
                            else {
                                toastr.error("Labels must have unique names");
                            }
                        }}
                        className="btn btn-sm btn-block btn-orange" style={{paddingTop: 9, paddingBottom: 9}}
                        disabled={this.state.labels.length === 0 /*|| !this.state.labels.every(x => x.assigned&&x.assigned.length>0)*/}
                    >
                        FILL IN DATA
                    </Button>
                </div>
                <div style={{paddingLeft: 12, paddingRight: 12, paddingBottom: 12, width: '100%'}}>
                    <Button
                        onClick={() => {
                            if (this.checkLabelNamesValid()) {
                                this.setState({showGenerateDesignsModal: true})
                            }
                            else {
                                toastr.error("Labels must have unique names");
                            }
                        }}
                        className="btn btn-sm btn-block btn-orange"
                        style={{paddingTop: 9, paddingBottom: 9}}
                    >GENERATE</Button>
                </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = function (state) {
    return {
        user: state.user,
    }
};

const mapDispatchToProps = dispatch => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BulkEditPanel));